export default __webpack_public_path__ + "static/item_20-06269051547e1770dbfef058e5093d41.jpg";